module.exports = __webpack_public_path__ + "static/image-04-b-alternative@2x-1eb9fac4f6f39f8eee04dd52ef663978.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cookpad/image-04-b-alternative@2x.jpg
// module id = 350
// module chunks = 3627797113349 20562973939449 33019919093843